<h1 class="item-page-title-field">
  @if (item.firstMetadataValue('dspace.entity.type'); as type) {
    <div class="d-inline">
      {{ type.toLowerCase() + '.page.titleprefix' | translate }}
    </div>
  }
  <span class="dont-break-out">{{ dsoNameService.getName(item) }}</span>
</h1>
